import React from 'react';
import { useTable } from 'react-table';
import { Table } from 'react-bootstrap';
import Sidebar from "../layout/Sidebar";

const Notification = () => {
  // Sample data for the table
  const data = React.useMemo(
    () => [
      { id: 1, title: 'New Year offer Up to 50%', message: 'Raj', image: '' },
      { id: 2, title: 'Christmas Sale 30% off', message: 'Sara', image: '' },
      { id: 3, title: 'Valentine Special', message: 'John', image: '' },
    ],
    []
  );

  // Define the columns for the table
  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Title',
        accessor: 'title',
      },
      {
        Header: 'Message',
        accessor: 'message',
      },
      {
        Header: 'Image',
        accessor: 'image',
        Cell: ({ value }) => (value ? <img src={value} alt="Notification" /> : 'No image'),
      },
    ],
    []
  );

  // Use react-table hook to get table props and methods
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

  return (
    <section className="cart-page-section pt-100 pb-80 main-bg">
      <div className="container">
        <div className="row">
        <div class="col-md-3 myaccount-navigation py-3">
                <Sidebar />
            </div>
          <div className="col-md-9 padding-16-30">
            <div className="mb-3">
              <h4 className="section-title">Notification</h4>
            </div>
            <div className="card-body px-0">
              <div className="bootstrap-table bootstrap5">
                <div className="fixed-table-container">
                  <Table {...getTableProps()} striped bordered hover>
                    <thead>
                      {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {rows.map(row => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                              return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Notification;
